import React from 'react';

const Mamba = () => {
    return (
        <h1>Мамба дацан</h1>
        // <h1>Түмэнцогт</h1>
    )
}
export default Mamba;